var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('iframe',{attrs:{"fill-hight":"","src":"https://www.tarohanako.com/racinganalyzer/","width":"100%","height":"100%"}})])}
var staticRenderFns = []

export { render, staticRenderFns }